import { React, useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { useUserAuth } from "../auth";

const AuthRoute = (props) => {
	const { user } = useUserAuth();
	const { children } = props;
	const auth = getAuth();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	useEffect(() => {
		onAuthStateChanged(auth, (user) => {
			if (user) {
				setLoading(false);
				navigate("/");
			} else {
				console.log("unauthorised");
				navigate("/login");
			}
		});
	}, [auth]);

	if (loading) return <p>loading...</p>;

	return <>{children}</>;
};

export default AuthRoute;
